import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle, Check } from 'lucide-react';
export function ProductIncludes() {
  const includes = [{
    title: 'Ebook / guía completa',
    desc: 'Cómo usar el Protocolo 4P sin complicarlo'
  }, {
    title: 'Tablero de 30 días',
    desc: 'Marca tus 4 pilares diario sin obsesión'
  }, {
    title: 'Menú de acciones 0.1',
    desc: 'Opciones rápidas para días sin energía'
  }, {
    title: 'Plantilla “Día Caótico”',
    desc: 'Para cuando la vida te atropella (10 min)'
  }, {
    title: 'Checklist anti-culpa',
    desc: 'Qué hacer después de fallar (sin drama)'
  }, {
    title: 'Planner semanal 4P',
    desc: 'Para ver tu semana con claridad (1 página)'
  }];
  return <div className="py-20 bg-cream-dark" data-id="element-134">
      <Section data-id="element-135">
        <h2 className="text-3xl md:text-4xl mb-12 text-center" data-id="element-136">
          Qué incluye Reset 4 Pilares
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-20" data-id="element-137">
          {includes.map(item => <div key={item.title} className="flex gap-4 p-4 bg-white rounded-xl shadow-sm" data-id="element-138">
              <CheckCircle2 className="text-sage h-6 w-6 flex-shrink-0" data-id="element-139" />
              <div data-id="element-140">
                <h3 className="font-bold text-lg mb-1" data-id="element-141">{item.title}</h3>
                <p className="text-brown-light text-sm" data-id="element-142">{item.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm" data-id="element-143">
          <h2 className="text-3xl md:text-4xl mb-12 text-center" data-id="element-144">
            Para quién es (y para quién no)
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-145">
            <div data-id="element-146">
              <h3 className="text-xl font-bold mb-6 flex items-center gap-2 text-sage-dark" data-id="element-147">
                <Check className="h-6 w-6" data-id="element-148" /> Es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-149">
                {['Estás cansado de empezar y abandonar', 'Quieres estructura simple', 'Vives con estrés real', "Necesitas un plan que funcione incluso cuando no estás 'bien'"].map(item => <li key={item} className="flex gap-3 text-brown/90" data-id="element-150">
                    <span className="text-sage" data-id="element-151">•</span> {item}
                  </li>)}
              </ul>
            </div>

            <div data-id="element-152">
              <h3 className="text-xl font-bold mb-6 flex items-center gap-2 text-terracotta" data-id="element-153">
                <XCircle className="h-6 w-6" data-id="element-154" /> No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-155">
                {['Quieres un reto extremo o disciplina militar', 'Buscas promesas mágicas', 'No estás dispuesto a hacer mínimos diarios'].map(item => <li key={item} className="flex gap-3 text-brown/90" data-id="element-156">
                    <span className="text-terracotta" data-id="element-157">•</span> {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}